module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0070.jpg?v=5f7935c5";